// from https://datatracker.ietf.org/doc/html/rfc8785

export const toCanonicalJsonString = function(object: unknown) {
		let buffer = '';
		function serialize(object: unknown) {
			if (object === null || typeof object !== 'object' ||
				(object as {toJSON?: () => string}).toJSON != null) {
				/////////////////////////////////////////////////
				// Primitive type or toJSON, use "JSON"        //
				/////////////////////////////////////////////////
				buffer += JSON.stringify(object);
			} else if (Array.isArray(object)) {
				/////////////////////////////////////////////////
				// Array - Maintain element order              //
				/////////////////////////////////////////////////
				buffer += '[';
				let isNotFirstItemInArray = false;
				object.forEach((element) => {
					if (isNotFirstItemInArray) {
							buffer += ',';
					}
					isNotFirstItemInArray = true;
					/////////////////////////////////////////
					// Array element - Recursive expansion //
					/////////////////////////////////////////
					serialize(element);
				});
				buffer += ']';
			} else {
				/////////////////////////////////////////////////
				// Object - Sort properties before serializing //
				/////////////////////////////////////////////////
				buffer += '{';
				let isNotFirstFieldInObject = false;
				Object.entries(object).sort(([keyA], [keyB]) => keyA < keyB ? -1 : keyA > keyB ? 1 : 0).forEach(([property, value]) => {
					if (isNotFirstFieldInObject) {
						buffer += ',';
					}
					isNotFirstFieldInObject = true;
					/////////////////////////////////////////////
					// Property names are strings, use "JSON"  //
					/////////////////////////////////////////////
					buffer += JSON.stringify(property);
					buffer += ':';
					//////////////////////////////////////////
					// Property value - Recursive expansion //
					//////////////////////////////////////////
					serialize(value);
				});
				buffer += '}';
			}
		}
		serialize(object);
		return buffer;
	};